import { TFunction } from 'i18next'
import { object, SchemaOf, string } from 'yup'

import { User } from '@modules-deprecated/app/user'

import { NAME_REGEX } from '../../../../../constants/nameRegex'
import { LocaleIdentifier } from '../../../../../types/localeIdentifier'

export interface UserProfileForm {
  name: string
  email: string
  phone: string | undefined
}

export type UserProfileFormSchema = SchemaOf<UserProfileForm>

const isDenmarkBasedOrganization = (locale: LocaleIdentifier) => locale === 'da_DK'

export const getValidationSchema = (t: TFunction): UserProfileFormSchema =>
  object({
    name: string()
      .trim()
      .required(t('settings.user.field.name.required'))
      .matches(NAME_REGEX, t('settings.user.field.name.invalid_characters')),
    email: string()
      .email(t('settings.user.field.email.wrong_format'))
      .required(t('settings.user.field.email.required')),
    phone: string().when('locale', {
      is: isDenmarkBasedOrganization,
      then: (schema) => schema.min(8, t('settings.user.field.phone.wrong_format')),
      otherwise: (schema) => schema.optional(),
    }),
  })

export const getDefaultValues = (user?: User): UserProfileForm => ({
  name: user?.name || '',
  email: user?.email || '',
  phone: user?.phone || '',
})
